import React, { ReactNode } from 'react';

import classNames from 'classnames';
import {
    ComboBox as ComboBoxBase,
    FieldError,
    Group,
    Input,
    Label,
    ListBox,
    Popover,
    Text,
} from 'react-aria-components';

import { combineClasses } from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ComboBox.scss';

interface ComboBoxProps {
    children?: ReactNode;
    classes?: object;
    className?: string;
    description?: string;
    errorMessage?: string;
    Icon?: React.ElementType;
    items?: {
        children?: {
            Icon?: React.ElementType;
            id: string | number;
            name?: string;
        }[];
        Icon?: React.ElementType;
        id?: string | number;
        name?: string;
    }[];
    label?: string;
    name: string;
    onInputChange?(value: string | null): void;
    onSelectionChange?(...args: unknown[]): unknown;
    placeholder?: string;
}

function ComboBox(props: ComboBoxProps) {
    const {
        children,
        className,
        classes: classesProp = {},
        description,
        errorMessage,
        Icon,
        label,
        name,
        placeholder,
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <ComboBoxBase
            className={classNames(classes.container, className)}
            allowsCustomValue
            shouldFocusWrap
            {...otherProps}
        >
            {label && <Label className={classes.label}>{label}</Label>}
            <Group className={classes.inputContainer}>
                {Icon && <Icon className={classes.inputIcon} />}
                <Input
                    className={classNames(classes.input, { [styles.withIcon]: !!Icon })}
                    data-id={name}
                    placeholder={placeholder}
                />
            </Group>
            {description && <Text slot="description">{description}</Text>}
            <FieldError>{errorMessage}</FieldError>
            <Popover className={classes.dropdown} shouldFlip={false}>
                <ListBox className={classes.listBox}>
                    {children}
                </ListBox>
            </Popover>
        </ComboBoxBase>
    );
}

export default ComboBox;
